import * as Yup from "yup";

const formatoIp =
  /^((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/;

const controleAcessoValidator = {
  ipAcesso: Yup.string()
    .nullable()
    .when("controleAcesso", {
      is: true,
      then: (schema) => schema.matches(formatoIp, "IP Fixo inválido"),
    }),
  horariosAcesso: Yup.array().when("controleAcesso", {
    is: true,
    then: (schema) =>
      schema
        .min(1, "Selecione pelo menos um dia da semana")
        .test(
          "entradaAntesDaSaida",
          "A saída deve ser maior que a entrada",
          (horarios) =>
            horarios.every(
              ({ entrada, saida }) => entrada && saida && entrada < saida,
            ),
        ),
  }),
};

export default controleAcessoValidator;
